import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '~/ui/core/dropdown-menu/DropdownMenu';
import { IconHorizontalDots } from '~/ui/core/icons';
import { Switch } from '~/ui/core/switch/Switch';

import { useWarningSignalsVisible } from '../../app/common/hooks/use-warning-signals-visible';
import { useUpdateCompanySettings } from '../../company-settings/api/use-update-company-settings';
import { useJobArchitecturePermissions } from '../context/JobArchitecturePermissionsContext';

export const SkillsSectionOptions: FunctionComponent = () => {
    const translate = useTranslate();
    const { canModify } = useJobArchitecturePermissions();
    const isWarningSignalsVisible = useWarningSignalsVisible();
    const { mutate: updateSettings } = useUpdateCompanySettings();

    if (!canModify) {
        return null;
    }

    const handleToggleWarningSignals = (event: Event): void => {
        event.preventDefault();
        updateSettings({
            payload: { warningSignalsVisible: !isWarningSignalsVisible },
        });
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger>
                <button
                    className="inline-flex items-center justify-center p-xs text-gray-600 hover:text-gray-900 outline-none bg-transparent border-none cursor-pointer"
                    type="button"
                >
                    <IconHorizontalDots size={12} />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent side="top">
                <DropdownMenuItem onSelect={handleToggleWarningSignals}>
                    <div className="flex items-center justify-between gap-m w-full">
                        <span>{translate('pages.company-settings.skills.warning-signals.title')}</span>
                        <Switch checked={isWarningSignalsVisible} />
                    </div>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
